export const useLocalizedImage = () => {
  const { locale } = useI18n()

  /**
   * Get localized image path based on current locale
   * @param basePath - Base image path (e.g., '/images/hero-couple.webp')
   * @param options - Optional configuration
   * @returns Localized image path (e.g., '/images/hero-couple-zh.webp')
   */
  const getLocalizedImage = (
    basePath: string,
    options?: {
      fallbackToDefault?: boolean // If true, falls back to base path if localized version doesn't exist
      defaultLocale?: string // Default locale to use (default: 'en')
    }
  ): string => {
    const lastSlash = basePath.lastIndexOf('/')
    const lastDot = basePath.lastIndexOf('.')

    // Handle edge cases
    if (lastSlash === -1 || lastDot === -1 || lastDot < lastSlash) {
      return basePath
    }

    const dir = basePath.substring(0, lastSlash)
    const filename = basePath.substring(lastSlash + 1, lastDot)
    const ext = basePath.substring(lastDot)

    // Return localized path: /images/hero-couple-zh.webp
    return `${dir}/${filename}-${locale.value}${ext}`
  }

  /**
   * Get localized image with fallback to English version
   * @param basePath - Base image path
   * @returns Localized image path with -en fallback
   */
  const getLocalizedImageWithFallback = (basePath: string): string => {
    const lastSlash = basePath.lastIndexOf('/')
    const lastDot = basePath.lastIndexOf('.')

    if (lastSlash === -1 || lastDot === -1 || lastDot < lastSlash) {
      return basePath
    }

    const dir = basePath.substring(0, lastSlash)
    const filename = basePath.substring(lastSlash + 1, lastDot)
    const ext = basePath.substring(lastDot)

    // If current locale is English, return English version
    if (locale.value === 'en') {
      return `${dir}/${filename}-en${ext}`
    }

    // Otherwise, return localized version (you could add error handling here)
    return `${dir}/${filename}-${locale.value}${ext}`
  }

  return {
    getLocalizedImage,
    getLocalizedImageWithFallback
  }
}
